module.exports = __webpack_public_path__ + "img/alex5.b7f12b58.png";